import { HttpMethod, type IHttpClient } from '@/shared/contracts/http-client.contract';
import type { IUseCase } from '@/shared/contracts/use-case.contract';
import { atendimentoEndpoint, type AtendimentoVendaDetalhe } from '../types';

type Input = { slug: string; orderId: string };

export class GetPedidoAtendimentoUseCase implements IUseCase<Input, AtendimentoVendaDetalhe> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute({ slug, orderId }: Input): Promise<AtendimentoVendaDetalhe> {
    const response = await this.client.sendRequest<{ data: AtendimentoVendaDetalhe }, never>({
      endpoint: `${atendimentoEndpoint(slug)}/pedidos/${encodeURIComponent(orderId)}`,
      method: HttpMethod.GET,
    });

    return response.data;
  }
}
